import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { footerLinks } from 'modules/auth/constants/footerLinks';
import { getLoginByCorporateId } from 'modules/auth/utils/getLoginByCorporateId';

type LoginFooterProps = {
  customStyle?: {
    societyName: string;
  };
};
const LoginFooter: FC<LoginFooterProps> = ({ customStyle }) => {
  const { t } = useTranslate();

  const currentYear = new Date().getFullYear();
  const { societyName } = customStyle || getLoginByCorporateId();

  return (
    <div className="nk-block nk-auth-footer">
      <div className="nk-block-between">
        <ul className="nav nav-sm">
          {Object.values(footerLinks).map(({ url, text }) => (
            <li key={text} className="nav-item">
              <a
                className="nav-link"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(text)}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-3">
        <p className="text-nowrap">
          © {currentYear} {societyName} | {t('AllRightsReserved')}
        </p>
      </div>
    </div>
  );
};

export default LoginFooter;
